import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";

import LoginPage from "./pages/Login/Login";
import StartPage from "./pages/Start/Start";
import StatisticsPage from "./pages/Statistics/Statistics";

import AccountTeam from "./pages/CheckLists/AccountsTeam/AccountTeam.js";
import CorporateActionsTeam from "./pages/CheckLists/CorporateActionsTeam/CorporateActionsTeam.js";
import IncomeTeamCountries from "./pages/CheckLists/IncomeTeam/IncomeTeamCountries";

import LeftPanelIncomeTeamNorway from "./pages/CheckLists/IncomeTeam/market/Norway/left-panel/LeftPanelIncomeTeamNorway.js";
import LeftPanelIncomeTeamFinland from "./pages/CheckLists/IncomeTeam/market/Finland/left-panel/LeftPanelIncomeTeamNorway.js";
import LeftPanelIncomeTeamDenmark from "./pages/CheckLists/IncomeTeam/market/Denmark/left-panel/LeftPanelIncomeTeamNorway.js";
import LeftPanelIncomeTeamSweden from "./pages/CheckLists/IncomeTeam/market/Sweden/left-panel/LeftPanelIncomeTeamNorway.js";







import IpaTeam from "./pages/CheckLists/IpaTeam/IpaTeam.js";
import SettlementTeam from "./pages/CheckLists/SettlementTeam/SettlementTeam.js";
import TaxTeam from "./pages/CheckLists/TaxTeam/TaxTeam.js";
import VotingTeam from "./pages/CheckLists/VotingTeam/VotingTeam.js";

export default function App() {
  const [user, setUser] = useState(null);

  if (!user) {
    return <LoginPage onLogin={setUser} />;
  }

  return (
    <Routes>
      <Route path="/" element={<StartPage user={user} />} />
      <Route path="/start" element={<StartPage user={user} />} />
      <Route path="/statistics" element={<StatisticsPage user={user} />} />

      <Route path="/account-team" element={<AccountTeam user={user} />} />
      <Route path="/corporate-actions-team" element={<CorporateActionsTeam user={user} />} />
      <Route path="/ipa-team" element={<IpaTeam user={user} />} />
      <Route path="/settlement-team" element={<SettlementTeam user={user} />} />
      <Route path="/tax-team" element={<TaxTeam user={user} />} />
      <Route path="/voting-team" element={<VotingTeam user={user} />} />
      <Route path="/income-team" element={<IncomeTeamCountries user={user} />} />

      <Route path="/income-team/norway" element={<LeftPanelIncomeTeamNorway user={user} />} />
      <Route path="/income-team/finland" element={<LeftPanelIncomeTeamFinland user={user} />} />
      <Route path="/income-team/denmark" element={<LeftPanelIncomeTeamDenmark user={user} />} />
      <Route path="/income-team/sweden" element={<LeftPanelIncomeTeamSweden user={user} />} />
      
    </Routes>
  );
}
